import PropTypes from 'prop-types';

import { connectLocation } from '../../../../location/LocationConnectors';
import { getClimateZone, getMinimumRSI } from '../../helpers';
import { SummaryInline } from '../../styles';

export const ComplianceHeader = connectLocation(({ hdd, results, calcId, t }) => {
  const climateZone = getClimateZone(hdd);
  const minimumRSI = getMinimumRSI({ climateZone, calcId });
  const effectiveAssemblyRSI = results?.effectiveAssemblyRSI?.toFixed(2);
  const isCompliant = effectiveAssemblyRSI > minimumRSI;

  return (
    <SummaryInline>
      <div>
        <strong>{t('thermal_calculator.header.climate_zone')}</strong>
      </div>
      <div>{climateZone || '—'}</div>

      <div>
        <strong>{t('thermal_calculator.header.minimum_rsi')}</strong>
      </div>
      <div>{minimumRSI || '—'}</div>

      {effectiveAssemblyRSI && (
        <>
          <div>
            <strong>{t('thermal_calculator.header.effective_r_value')}</strong>
          </div>
          <div>{effectiveAssemblyRSI || '—'}</div>
        </>
      )}

      {effectiveAssemblyRSI && (
        <>
          <div>
            <strong>{t('thermal_calculator.header.compliant')}</strong>
          </div>
          <div>{isCompliant ? t('thermal_calculator.answer_yes') : t('thermal_calculator.answer_no')}</div>
        </>
      )}
    </SummaryInline>
  );
});

ComplianceHeader.propTypes = {
  t: PropTypes.func.isRequired,
  calcId: PropTypes.string.isRequired,
  hdd: PropTypes.number,
  results: PropTypes.shape({
    effectiveAssemblyRSI: PropTypes.number,
  }),
};

ComplianceHeader.defaultProps = {
  hdd: null,
  results: null,
};
